import React from 'react';

import { FlexColumn } from '@editor/components/utilities/layouts';
import InfoIcon from '@repo/ui/components/Icon/InfoIcon';
import { H5, P3 } from '@repo/ui/components/Typography';
import { themeStyle } from '@repo/ui/theming';

import { InfoIconModalContent } from '../../types/Pricing';
import Popover from '../Popover/Popover';
import { PopoverAlign, PopoverPlacement } from '../Popover/types';

import { InfoIconWrapper } from './styles';

const popoverTheme = {
  padding: '16px',
};

const InfoIconModalPopover: React.FC<{
  infoModalData: InfoIconModalContent;
}> = ({ infoModalData }) => {
  const infoIconModalContentElement = (
    <FlexColumn gap="8px">
      <H5>{infoModalData?.title}</H5>
      <P3>{infoModalData?.content}</P3>
    </FlexColumn>
  );

  return (
    <Popover
      hideTip
      useHover
      align={PopoverAlign.Start}
      content={infoIconModalContentElement}
      placement={PopoverPlacement.Right}
      showHeader={false}
      theme={popoverTheme}
      width="260px"
    >
      <InfoIconWrapper>
        <InfoIcon height="16px" theme={{ color: themeStyle.varInkMedium }} />
      </InfoIconWrapper>
    </Popover>
  );
};

export default InfoIconModalPopover;
